import actions from "./actions";

const {
    FETCH_APPOINTED_TEACHER,
    FETCH_APPOINTED_TEACHERS,
    RESET_APPOINTED_TEACHER
} = actions;

const initState = {
    appointedTeachers: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    appointedTeacher: { _id: null }
};

const AppointedTeacherReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {

        case FETCH_APPOINTED_TEACHERS:
            return {
                ...state,
                appointedTeachers: data
            };

        case RESET_APPOINTED_TEACHER:
            return {
                ...state,
                appointedTeacher: initState.appointedTeacher
            };

        case FETCH_APPOINTED_TEACHER:
            return {
                ...state,
                appointedTeacher: data
            };

        default:
            return state;
    }
};

export default AppointedTeacherReducer;
